import React from "react";
import { useLocation } from 'react-router-dom';
import Header from "./Header";
import Footer from "./Footer";
import MobileFooter from './MobileFooter';
import { Container, Eyebrow, Heading, Card } from '../ui';

const TermsAndConditions = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isEmbedded = searchParams.get('embed') === '1';
  return (
    <div className={`min-h-screen bg-bg ${isEmbedded ? '' : 'pb-20 lg:pb-0'} font-sans`}>
      {!isEmbedded && <Header />}

      {/* Hero */}
      <div className="on-dark bg-navy py-14 sm:py-20 px-4">
        <Container width="wide" className="text-left">
          <Eyebrow>Legal</Eyebrow>
          <Heading variant="display" className="mt-3 text-3xl sm:text-4xl md:text-5xl">
            Terms &amp; <em className="kbc-serif">Conditions</em> for Signup
          </Heading>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-text">
            Please review the terms below before completing your KBC member registration.
          </p>
        </Container>
      </div>

      {/* Content */}
      <Container width="wide" className="py-10 sm:py-14 md:py-16 text-left">
        <div className="space-y-8">
          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">1. Platform Ownership</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              This business directory platform is owned by Thulir Technology and licensed to Kongu Business Community (KBC) for operation and management.
            </p>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">2. Information You Provide</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              During signup, you may provide personal, family, and business information, including but not limited to name, email, phone number, business details, and related data.
            </p>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">3. Consent to Use of Data</Heading>
            <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base text-text">
              <li>Grant KBC the right to collect, store, and display your data as part of the business directory.</li>
              <li>Consent to be contacted by KBC or its authorized representatives for purposes related to directory services, networking, and communication.</li>
            </ul>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">4. Data Ownership &amp; Responsibility</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              All submitted data remains under the responsibility of KBC as the licensee. Thulir Technology, as the platform provider, does not claim ownership of your data and ensures it is hosted securely.
            </p>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">5. No Misuse of Data</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              Neither KBC nor Thulir Technology will sell, rent, or misuse your information for unrelated purposes.
            </p>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">6. Accuracy of Information</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              You are responsible for ensuring that the information provided is accurate, lawful, and up to date.
            </p>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">7. Opt-Out &amp; Removal</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              You may request modification or deletion of your information at any time by contacting KBC.
            </p>
          </section>

          <section>
            <Heading as="h2" variant="title" className="mb-3 text-2xl sm:text-3xl">8. Acceptance</Heading>
            <p className="text-sm sm:text-base leading-relaxed text-text">
              By checking the box and completing signup, you confirm that you have read and agreed to these Terms &amp; Conditions.
            </p>
            <Card padding="sm" className="mt-4 text-sm text-text">
              [ ] I agree to the Terms &amp; Conditions and consent to my information being used by KBC for the business directory.
            </Card>
          </section>
        </div>
      </Container>

      {!isEmbedded && <Footer />}
      {!isEmbedded && <MobileFooter />}
    </div>
  );
};

export default TermsAndConditions;
